import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { UnscheduleSubtask as UnscheduleSubtaskCommand } from "@/api/storymapCardDetails/commands";
import { useSendCommand } from '@/_core/cqrs/use';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class UnscheduleSubtask extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'UnscheduleSubtask';

    public constructor(public id: string) {
        super(UnscheduleSubtask.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: UnscheduleSubtask): Promise<boolean> => {
    const card = state.subtasks.find(x => x.id == action.id);
    const release = state.releases.find(x => x.id == card.releaseId);

    const cmd = await UnscheduleSubtaskCommand.create(card.id, state.id, card.title, release.id, release.name);

    return useSendCommand(action, {
        createCommand: () => cmd,
    });
};

const reducer = (state: StorymapState, action: UnscheduleSubtask): void => {
    const card = state.subtasks.find(x => x.id == action.id);
    const siblings = state.subtasks.filter(x => x.taskId == card.taskId && x.releaseId == null);
    const order = siblings.length === 0 ? 0 : Math.max(...siblings.map((x) => x.order)) + 1;
    card.order = order;
    card.releaseId = null;
};

//@ts-ignore
registerMiddleware(UnscheduleSubtask.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(UnscheduleSubtask.ACTION_TYPE, reducer);